import React from 'react'

export function DuprReplay() {
  // Batch ID is final part of the deep link to open the Replay in the app
  // Get final part of url
  const urlParts = window.location.pathname.split('/')
  const batchId = urlParts[urlParts.length - 1]

  const deepLink = `dupr://dashboard/replay/${batchId}`
  const appStoreUrl = 'https://apps.apple.com/us/app/dupr/id1567932355'
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=gg.dupr&hl=en_US'
  const dashboardUrl = '/dashboard'

  return (
    <div style={styles.page}>
      <div style={styles.bgGlow} aria-hidden="true" />
      <main style={styles.shell}>
        <header style={styles.header}>
          <a href={dashboardUrl} style={styles.topLink}>
            ← Go to DUPR Dashboard
          </a>
        </header>

        <section style={styles.card}>
          <div style={styles.hero}>
            <div style={styles.logoWrap}>
              <img src="/img/replay-logo.png" alt="DUPR Replay" style={styles.logo} />
            </div>

            <div style={styles.heroText}>
              <h1 style={styles.h1}>DUPR Replay lives in the app</h1>
              <p style={styles.sub}>
                Replay is your year-in-review for pickleball—highlights, trends, and stats, presented like stories.
              </p>

              <div style={styles.ctaRow}>
                <a href={deepLink} style={styles.primaryBtn}>
                  Open Replay in the app
                </a>
                <a href={dashboardUrl} style={styles.secondaryBtn}>
                  Continue on web
                </a>
              </div>

              <div style={styles.storeRow}>
                <span style={styles.storeLabel}>Don’t have the app?</span>
                <a href={appStoreUrl} style={styles.storeLink}>
                  Download on iOS
                </a>
                <span style={styles.dot}>•</span>
                <a href={playStoreUrl} style={styles.storeLink}>
                  Download on Android
                </a>
              </div>

              <p style={styles.note}>
                If you tapped this from an email on mobile, the app should open automatically. If it didn’t, use “Open
                Replay in the app” above.
              </p>
            </div>
          </div>

          <div style={styles.divider} />

          <div style={styles.grid}>
            <div style={styles.panel}>
              <h2 style={styles.h2}>What you’ll see in Replay</h2>
              <ul style={styles.list}>
                <li>Match mix + activity highlights</li>
                <li>Rating movement and milestones</li>
                <li>Your toughest opponents and best runs</li>
                <li>Sharable slides (perfect for flexing)</li>
              </ul>
            </div>

            <div style={styles.panel}>
              <h2 style={styles.h2}>On desktop?</h2>
              <p style={styles.p}>
                Replay is app-only for now, but you can still use the web dashboard to view your profile, matches, and
                ratings.
              </p>
              <a href={dashboardUrl} style={styles.inlineBtn}>
                Go to Dashboard →
              </a>
            </div>
          </div>

          <footer style={styles.footer}>
            <span style={styles.footerText}>Need help?</span>
            <a href="/support" style={styles.footerLink}>
              Contact Support
            </a>
          </footer>
        </section>
      </main>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    // background: '#070A0F',
    color: '#E9EEF8',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"',
  },
  bgGlow: {
    position: 'absolute',
    inset: '-20%',
    background:
      'radial-gradient(closest-side, rgba(93, 232, 255, 0.20), rgba(93, 232, 255, 0) 60%), radial-gradient(closest-side, rgba(149, 99, 255, 0.18), rgba(149, 99, 255, 0) 55%)',
    filter: 'blur(40px)',
    pointerEvents: 'none',
  },
  shell: {
    width: '100%',
    maxWidth: 980,
    padding: '28px 18px 48px',
    position: 'relative',
    zIndex: 1,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 14,
  },
  topLink: {
    color: 'rgba(233, 238, 248, 0.85)',
    textDecoration: 'none',
    fontSize: 14,
  },
  card: {
    background: 'rgba(12, 16, 24, 0.72)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: 18,
    boxShadow: '0 18px 60px rgba(0,0,0,0.45)',
    overflow: 'hidden',
  },
  hero: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr',
    gap: 18,
    padding: 22,
  },
  logoWrap: {
    width: 120,
    height: 120,
    borderRadius: 18,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.10)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    maxWidth: '76%',
    maxHeight: '76%',
    objectFit: 'contain',
    display: 'block',
  },
  heroText: {
    minWidth: 0,
  },
  h1: {
    margin: '2px 0 8px',
    fontSize: 34,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
  },
  sub: {
    margin: '0 0 16px',
    fontSize: 16,
    lineHeight: 1.5,
    color: 'rgba(233, 238, 248, 0.82)',
    maxWidth: 640,
  },
  ctaRow: {
    display: 'flex',
    gap: 10,
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  primaryBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 14px',
    borderRadius: 12,
    background: 'linear-gradient(225deg, rgba(75, 151, 254, 1) 0%, rgba(1, 99, 208, 1) 40%',
    color: '#070A0F',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: 14,
  },
  secondaryBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 14px',
    borderRadius: 12,
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.14)',
    color: '#E9EEF8',
    textDecoration: 'none',
    fontWeight: 650,
    fontSize: 14,
  },
  storeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    marginTop: 2,
    color: 'rgba(233, 238, 248, 0.78)',
    fontSize: 13,
  },
  storeLabel: {
    opacity: 0.9,
  },
  storeLink: {
    color: '#BFE9FF',
    textDecoration: 'none',
    fontWeight: 650,
  },
  dot: {
    opacity: 0.6,
  },
  note: {
    margin: '12px 0 0',
    fontSize: 13,
    lineHeight: 1.45,
    color: 'rgba(233, 238, 248, 0.65)',
    maxWidth: 720,
  },
  divider: {
    height: 1,
    background: 'rgba(255,255,255,0.10)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 14,
    padding: 18,
  },
  panel: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: 14,
    padding: 16,
  },
  h2: {
    margin: '0 0 10px',
    fontSize: 16,
    letterSpacing: '-0.01em',
  },
  p: {
    margin: '0 0 12px',
    fontSize: 14,
    lineHeight: 1.55,
    color: 'rgba(233, 238, 248, 0.78)',
  },
  list: {
    margin: 0,
    paddingLeft: 18,
    color: 'rgba(233, 238, 248, 0.78)',
    lineHeight: 1.8,
    fontSize: 14,
  },
  inlineBtn: {
    display: 'inline-flex',
    padding: '10px 12px',
    borderRadius: 12,
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.14)',
    color: '#E9EEF8',
    textDecoration: 'none',
    fontWeight: 650,
    fontSize: 14,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
    padding: '14px 18px 18px',
    color: 'rgba(233, 238, 248, 0.70)',
    fontSize: 13,
  },
  footerText: {
    opacity: 0.9,
  },
  footerLink: {
    color: '#BFE9FF',
    textDecoration: 'none',
    fontWeight: 650,
  },
}
